import { Component, Input, OnInit } from '@angular/core';
import { PopoverController, NavParams } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { AppRateService } from "../../services/app-rate/app-rate.service";
import { ConfigService } from "../../services/config/config.service";
import { Navigator } from 'src/app/services/routing/navigator';
import { InAppReview } from '@capacitor-community/in-app-review';
import { EventsService } from 'src/app/services/event/event.service';
import { DailySpinService } from 'src/app/services/daily-spin/daily-spin.service';
import { RoutingService } from 'src/app/services/routing/routing.service';

@Component({
  selector: 'app-popover-daily-spin-result',
  templateUrl: './popover-daily-spin-result.component.html',
  styleUrls: ['./popover-daily-spin-result.component.scss'],
})

export class PopoverDailySpinResultComponent implements OnInit {
  @Input() data: any;

  public winLossText: String = "";
  public numberOfEntry: Number = 0;
  public textEntryText: String = "";
  public numberOfSpinLeft: Number = 0;
  public spinLeftText: string = "";
  public autoCloseResultPopTimer: any = 0;
  protected titlelabel: string = "";

  constructor(
    private config: ConfigService,
    private dailySpinService: DailySpinService,
    private events: EventsService,
    private navigator: Navigator,
    private platform: Platform,
    private routing: RoutingService,
  ) {
  }

  ngOnInit(): void {
    this.winLossText = this.data.winLossText;
    this.winLossText = this.data.winLossText;
    this.textEntryText = "You got " + this.data.numberOfEntry + " more entries.";
    this.numberOfEntry = this.data.numberOfEntry;
    this.spinLeftText = "You have " + this.data.numberOfSpinLeft + " spins available.";
    this.numberOfSpinLeft = this.data.numberOfSpinLeft;
    this.autoCloseResultPopTimer = setTimeout(() => {
      this.closePop();
    }, 15000);
  }



  public spinnow() {
    this.closePop();
    this.dailySpinService.setDailySpinGameUrl();
    this.events.publish("event:dailyspin.spinnow", { slotUrl: this.dailySpinService.getDailySpinGameUrl() });
  }

  public closePop() {
    if (this.autoCloseResultPopTimer) {
      clearTimeout(this.autoCloseResultPopTimer);
    }
    this.navigator.activePopovers[this.navigator.activePopovers.length - 1].dismiss();
  }

  public onClose() {
    this.closePop();
    this.routing.defaultRoute();
  }

}
